<main-header></main-header>
<main>
    <div class="container">
        <div class="top-part">
            <div class="breadcrumb">
                <import-navigator currentStep="outcomeColumn"></import-navigator>
                <div class="wrap-text">
                    <b>
                        Confirm basis for evaluating relative impact
                    </b>
                    <span>
                        In case multiple options were available
                    </span>
                </div>
            </div>
        </div>
        <div [ngClass]="{'loading':!dataLoaded, 'middle-part' :true, 'set-up':true}">
            <div class="current-status">
                <div class="left">
                    <div class="dot"></div>
                    <div class="dot green"></div>
                    <div class="dot"></div>
                </div>
                <div class="divider"></div>
                <div class="right">
                    <div class="wrap">
                        Define a strategy for results that do not exist in both {{oldControlValue}} and {{newControlValue}}:
                    </div>
                    <div class="wrap">
                        <div *ngIf="selectedColumn" class="radio-column">
                            <form [formGroup]="form">
                                <div class="form-choice">
                                    <input type="radio" id="existence2" formControlName="existenceFrmCtrl" name="existenceFrmCtrl"
                                           [value]="false" class="form-choice-radio">
                                    <label class="form-choice-label" for="existence2">
                                        Do not break down “New” and “Lost” variance <help-link helpId="17"></help-link>
                                        <small>
                                            With this option, if certain results only exist in {{oldControlValue}} or {{newControlValue}}, [{{outcomeName}}]
                                            variance is not broken down into “New” or “Lost” impact.
                                        </small>
                                    </label>
                                </div>
                                <div class="form-choice">
                                    <input type="radio" id="existence1" formControlName="existenceFrmCtrl" name="existenceFrmCtrl"
                                           [value]="true" class="form-choice-radio">
                                    <label class="form-choice-label" for="existence1">
                                        Break down “New” and “Lost” variance under <b class="text-bracket">{{selectedColumn.name}}</b> <span>–
                                        click on another component to change</span> <help-link helpId="18"></help-link>
                                        <small>
                                            With this option, if certain results (e.g. linked to a certain new product)
                                            do not exist in {{oldControlValue}} but exist in {{newControlValue}}, the related [{{outcomeName}}] variance will
                                            be broken down as “New” impact under [{{selectedColumn.name}}].
                                        </small>
                                    </label>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="wrap">
                        <button autofocus (click)="save(true)" [ngClass]="{'loading-small':loading, 'btn':true, 'btn-green':true, 'btn-small':true}">Jump</button> to selecting dimensions, or <button (click)="save(false)" [ngClass]="{'loading-small':loading, 'btn':true, 'btn-gray':true, 'btn-small':true}">continue here</button> to review intermediate details
                    </div>
                </div>
            </div>

            <div class="table-data">
                <table>
                    <thead>
                    <tr>
                        <th *ngFor="let col of columns" (click)="selectColumn(col)" [ngClass]="{'eligible': col.isEligible, 'selected': col.isSelected}">
                            <span *ngIf="col.wasSelectedBefore" class="icon-check">✓</span> {{col.name}}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="small-font">
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'selected': col.isSelected}">
                            <ng-container *ngIf="col.isNumerical">
                                <b class="green">#</b>,&nbsp;
                            </ng-container>
                            {{ displayRoughNum(col.uniqueValues) }}
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length">
                                <div class="gray">
                                    {{col.someVals[0]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 1">
                                <div class="gray">
                                    {{col.someVals[1]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 2">
                                <div class="gray">
                                    {{col.someVals[2]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 3">
                                <div class="gray">
                                    {{col.someVals[3]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 4">
                                <div class="gray">
                                    {{col.someVals[4]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</main>
